import { bankHolidays } from '@/helpers/constants/openingHours'

function isBankHoliday (date) {
  const bankHolidaysDates = bankHolidays.map(item => item.date)
  return bankHolidaysDates.indexOf(date) > -1
}

export default isBankHoliday
